import { isAxiosError } from 'axios';
import { axios as api } from './api';

const routePrefix = '/urls';

export const getFileUrl = async (
  fileId: number,
  partnerName?: string | null
): Promise<string> => {
  return api.get(
    `${routePrefix}/file/${fileId.toString()}?partnerName=${partnerName}`
  );
};

export const downloadFilesAsZip = async (
  fileIds: number[],
  partnerName: string | null,
  format: 'zip' = 'zip'
): Promise<Blob> =>
  api.post(
    `${routePrefix}/files/download`,
    { fileIds, partnerName, format },
    { responseType: 'blob' }
  );

export const downloadArMonitoringSnapshots = async (
  organizationId: string,
  orchestrationExecutionIds: string[]
): Promise<Blob> =>
  api.post(
    '/ar-monitoring/snapshots/download',
    { organizationId, orchestrationExecutionIds },
    { responseType: 'blob' }
  );

export const extractFailedFiles = async (error: unknown): Promise<string[]> => {
  if (!isAxiosError(error) || !(error.response?.data instanceof Blob)) {
    return [];
  }
  try {
    const parsed: { failedFiles?: unknown } = JSON.parse(
      await error.response.data.text()
    );
    return Array.isArray(parsed?.failedFiles) ? parsed.failedFiles : [];
  } catch {
    return [];
  }
};
